import api from './api';

// 인증 관련 API 호출 함수들
export const authApi = {
  startAppleWeb: async (payload, config = {}) => {
    const response = await api.postPublic('/auth/apple/web/start', payload, {
      ...config,
      baseURL: '/api',
      skipAuthRecovery: true,
      omitPageQuery: true,
    });
    return response.data;
  },
  completeAppleWeb: async (payload, config = {}) => {
    const response = await api.postPublic('/auth/apple/web/complete', payload, {
      ...config,
      baseURL: '/api',
      skipAuthRecovery: true,
      omitPageQuery: true,
    });
    return response.data;
  },
  // 구글 로그인 페이지 접속
  getGoogleUrl: async (redirectUrl, config = {}) => {
    const response = await api.getPublic(
      `/auth/google/url?redirectUrl=${encodeURIComponent(redirectUrl || '/')}`,
      config,
    );
    return response.data;
  },

  // 구글 로그인 콜백
  getGoogleCallback: async (code) => {
    const response = await api.getPublic(`/auth/google/callback?code=${code}`);
    return response.data;
  },

  // 네이버 로그인 페이지 접속
  getNaverUrl: async (redirectUrl, config = {}) => {
    const response = await api.getPublic(
      `/auth/naver/url?redirectUrl=${encodeURIComponent(redirectUrl || '/')}`,
      config,
    );
    return response.data;
  },

  // 네이버 로그인 콜백
  getNaverCallback: async (code) => {
    const response = await api.getPublic(`/auth/naver/callback?code=${code}`);
    return response.data;
  },

  getKakaoUrl: async (redirectUrl, config = {}) => {
    const response = await api.getPublic(
      `/auth/kakao/url?redirectUrl=${encodeURIComponent(redirectUrl || '/')}`,
      config,
    );
    return response.data;
  },

  // 현재 유저 정보 조회
  getMe: async () => {
    const response = await api.getAuth('/auth/me');
    return response.data;
  },

  getMeWithToken: async (token, config = {}) => {
    const response = await api.get('/auth/me', {
      ...config,
      headers: { Authorization: `Bearer ${token}` },
      skipAuthRecovery: true,
      omitPageQuery: true,
    });
    return response.data;
  },

  // 로그인
  login: async (formData, config = {}) => {
    const response = await api.postPublic('/auth/login', formData, {
      ...config,
      skipAuthRecovery: true,
    });
    return response.data;
  },

  // 회원가입
  signup: async (userData, config = {}) => {
    const response = await api.postPublic('/auth/signup', userData, {
      ...config,
      skipAuthRecovery: true,
    });
    return response.data;
  },

  getSocialSignupInfo: async (token, config = {}) => {
    const response = await api.getPublic(`/auth/social-signup/${encodeURIComponent(token)}`, {
      ...config,
      skipAuthRecovery: true,
      omitPageQuery: true,
    });
    return response.data;
  },

  // 비밀번호 재설정 이메일 전송
  sendPasswordResetEmail: async (email, config = {}) => {
    const response = await api.postPublic('/auth/password/reset/email', { email }, config);
    return response.data;
  },

  // 비밀번호 재설정
  resetPassword: async (token, newPassword, config = {}) => {
    const response = await api.postPublic('/auth/password/reset', { token, newPassword }, config);
    return response.data;
  },

  // 비밀번호 변경 (로그인된 사용자용)
  changePassword: async (currentPassword, newPassword, config = {}) => {
    const response = await api.postAuth(
      '/auth/password/change',
      { currentPassword, newPassword },
      config,
    );
    return response.data;
  },

  // 이메일 상태 확인
  checkEmailStatus: async (email, config = {}) => {
    const response = await api.getPublic(
      `/auth/email-status?email=${encodeURIComponent(email)}`,
      config,
    );
    return response.data;
  },
};
